import { useMetaTags } from "react-metatags-hook";
import { Outlet, useLocation } from "react-router";
import PageHeader from "@/components/layout/page-header.jsx";
import { information } from "@/data/information.js";
import { getTypeSlug } from "@/util/common.js";
import { isTestMode } from "@/util/const.js";

export default function InformationPageLayout() {
  const location = useLocation();
  const { slug } = getTypeSlug(location.pathname);
  const pageInfo = information[slug];

  const { name, description } = pageInfo;
  const links = [
    {
      title: "Information",
      href: "/information",
    },
    {
      title: name,
    },
  ];

  useMetaTags(
    {
      title: `${pageInfo.name} | ${isTestMode ? "" : "St. Jude "}Play Live Tools`,
      description,
      openGraph: {
        type: "article",
        description,
      },
    },
    [name, description],
  );

  return (
    <div className="max-w-full relative flex flex-col items-center">
      <div className={`hero w-full pt-0 overflow-x-hidden`}>
        <div className="hero-content ml-6 pt-5 max-w-full w-full overflow-x-hidden flex-col items-start">
          <div>
            <PageHeader name={name} links={links} />
          </div>

          <div className="overflow-x-hidden w-full mb-4">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
